


































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import { currentScoutingStore } from "@/store/typed";
import VSwitchButton from "@monade/vue-components/src/components/VSwitchButton.vue";
import IsocronForm from "@/components/Isocron/Form.vue";
import IsocronsMixin from "@/mixins/http/IsocronsMixin";
import IsocronCable from "@/cables/isocronCable";

@Component({ components: { VSwitchButton, IsocronForm } })
export default class Show extends Mixins(IsocronsMixin) {
  private isocronEditable = this.differentIsocron;
  private loading = false;
  private importer: IsocronCable | null = null;

  get id() {
    return this.$route.params.id;
  }

  async onApply(payload: any) {
    this.loading = true;
    const response = await this.updateIsocron(payload);
    await currentScoutingStore.loadScoutingPlaces();
    this.loading = false;
  }

  get scoutingPlace() {
    return currentScoutingStore.scoutingPlaces.find((o) => this.id === o.id);
  }

  get isocron() {
    return this.scoutingPlace?.isocron;
  }

  get scouting() {
    return currentScoutingStore.scouting;
  }

  get hasIsocron() {
    return !!this.scouting?.hasIsocron;
  }

  get differentIsocron() {
    return this.scouting
      ? !this.scoutingPlace?.hasScoutingIsocron(this.scouting)
      : false;
  }

  mounted() {
    this.initExporter();
  }

  initExporter() {
    if (this.importer) {
      this.importer.close();
    }
    this.importer = new IsocronCable();
    this.importer.onResponse = this.onImporterResponse;
    this.importer.open();
  }

  onImporterResponse(data: any) {
    const isocron = this.$parseModel(data);
    if (!isocron) {
      return;
    }
    const place = currentScoutingStore.scoutingPlaces.find(
      (o) => o.isocron.id === isocron.id
    );

    if (place) {
      place.isocron = isocron;
      currentScoutingStore.saveScoutingPlaceOffline(place);
    }
  }

  destroyed() {
    this.importer?.close();
  }

  back() {
    currentScoutingStore.centerOnAllObjects();
    this.$router.go(-1);
  }
}
